import React, { useState } from "react";
import { Formik } from "formik";
import { RouteComponentProps } from "@reach/router";
import { adminSearchInterestsVariables } from "types/gql-types";

import { usePersistedSearch } from "../users/use-persisted-search";
import ResultTable from "./result-table";
import InterestSearchForm from "./form";

const initialData = {
  firstName: "",
  lastName: "",
  email: "",
  strict: true,
};

const InterestPage: React.FC<RouteComponentProps> = () => {
  const [hasSearched, setHasSearched] = useState(false);
  const [searchCriteria, setSearchCriteria] =
    useState<adminSearchInterestsVariables>(initialData);

  const [initialFormValues, searchSubmit] = usePersistedSearch(initialData, (variables) => {
    setHasSearched(true);
    setSearchCriteria(variables);
  });

  return <>
    <Formik initialValues={initialFormValues} onSubmit={searchSubmit}>
      {(state) => (<InterestSearchForm {...state} />)}
    </Formik>

    <hr />

    { hasSearched && <ResultTable {...searchCriteria} /> }

    <hr />
  </>;
};

export default InterestPage;
